import type {AppLanguageCode} from '../Utils/I18n';

/**
 * Display titles for the four DISC-5 modules, per language.
 *
 * The engine (src/Engine/criteria.ts `MODULE_TITLES`) is language-agnostic and
 * carries only the English titles, so the per-language module headers are
 * resolved here at the UI layer (keyed by the module target column).
 *
 * XiTsonga / Swahili are UNREVIEWED machine-draft seeds — like the rest of the
 * translations (see translations/<lang>/drafts.json), they must be verified by
 * a fluent speaker before any non-prototype use. English falls back to the
 * engine's `MODULE_TITLES`.
 */
const MODULE_TITLE_I18N: Partial<Record<AppLanguageCode, Record<string, string>>> = {
  ts: {
    y5soyima: "Ku chava ka vanhu van'wana",
    y5gayima: 'Ku vilela swilo swo tala',
    y5mdyima: 'Matitwelo yo tsana',
    y5ptyima: "Ntshikilelo endzhaku ka xiendlakalo xo nonon'hwa",
  },
  sw: {
    y5soyima: 'Wasiwasi wa kijamii',
    y5gayima: 'Wasiwasi wa jumla',
    y5mdyima: 'Hali ya chini ya moyo',
    y5ptyima: 'Msongo baada ya tukio gumu',
  },
  fr: {
    y5soyima: 'Anxiété sociale',
    y5gayima: 'Anxiété généralisée',
    y5mdyima: 'Baisse de moral',
    y5ptyima: 'Stress après un événement difficile',
  },
};

export const localizedModuleTitle = (
  target: string,
  language: AppLanguageCode,
  fallback: string,
): string => MODULE_TITLE_I18N[language]?.[target] ?? fallback;
